import {FunctionComponent} from "react"
import {Settings} from "types/settings"
import {FormLabel} from "components/Form"
import {BaseInput, BaseTextArea} from "components"
import {BaseDatePicker} from "components/DateTimePicker"
import {Checkbox} from "antd"

export const CustomFieldInfo: FunctionComponent<{
    type: Settings.CustomFieldType
    label: string
    value: string
    data?: any
    onChange: (value: string) => void
}> = ({type, label, value, onChange}) => {
    const renderContent = () => {
        switch (type) {
            case Settings.CustomFieldType.Text:
                return <BaseInput value={value} onChange={onChange} />
            case Settings.CustomFieldType.Number:
                return <BaseInput type="number" value={value} onChange={onChange} />
            case Settings.CustomFieldType.Paragraph:
                return <BaseTextArea value={value} onChange={onChange} />
            case Settings.CustomFieldType.Date:
                return <BaseDatePicker value={value} isUtcDate onChange={onChange} />
            case Settings.CustomFieldType.Checkbox:
                return (
                    <Checkbox checked={value === "true"} onChange={(event) => onChange(String(event.target.checked))} />
                )
            default:
                return null
        }
    }

    return (
        <div>
            <FormLabel label={label} />
            {renderContent()}
        </div>
    )
}
